import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import Pagination from "react-js-pagination";
import ContentIcon, { HEADING_ADVERTISEMENT } from "ContentIcon";
import {
  fetchAdvertisements,
  searchAdvertisements,
  openAdvtModal,
  advtBanners,
  loadAdvtData,
} from "ActionsAdvertisement";
import { fetchAllSponsors } from "ActionsSponsors";
import { fetchAllExhibitors } from "ActionsExhibitors";
import NoContent, { NO_ADVERTISEMENTS } from "NoContent";
import { itemCount, screenHeightLeftFromTop } from "Constants";
import AddNew from "./advt-add";
import ListItem from "./advt-list";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Advertisement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      pageNumber: 1,
      loading: true,
      desc: LocaleStrings.preparingAdvertisements,
    };
  }

  componentDidMount() {
    this.props.fetchAdvertisements(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
    this.props.fetchAllSponsors(this.props.session);
    this.props.fetchAllExhibitors(this.props.session);

    let banners = [
      {
        name: LocaleStrings.advt_form_screen_option1,
        value: "overviewinline",
        size: "1054x600",
      },
      {
        name: LocaleStrings.advt_form_screen_option2,
        value: "sidemenu",
        size: "858x300",
      },
      {
        name: LocaleStrings.advt_form_screen_option3,
        value: "splash",
        size: "1242x2208",
      },
      {
        name: LocaleStrings.advt_form_screen_option4,
        value: "home",
        size: "900x1500",
      },
      // { name:"Speaker", value: "speaker", size: "2238x3938", },
      // { name:"Sponsor", value: "sponsor", size: "2294x736", },
      // { name:"Sponsor", value: "exhibitor", size: "1132x736", },
    ];
    this.props.advtBanners(banners);
  }

  open = () => {
    this.props.openAdvtModal({ showModal: true });
    this.props.loadAdvtData({});
  };

  additionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search === "") {
      this.props.fetchAdvertisements(this.props.session, 0, (callback) => {});
    } else {
      this.props.searchAdvertisements(this.props.session, search, 0);
    }

    this.setState({ search, pageNumber });
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;

    if (search === "") {
      this.props.fetchAdvertisements(this.props.session);
    } else {
      this.props.searchAdvertisements(this.props.session, search, pageNumber);
    }

    this.setState({ ...this.state, pageNumber });
  };

  renderList = () => {
    let { pageNumber, advertisementsList } = this.props;
    let pageDataLength =
      advertisementsList.data && advertisementsList.data.length > 0
        ? advertisementsList.data.length
        : 1;

    var items = _.map(advertisementsList.data, (advt) => (
      <ListItem
        key={advt.advtid}
        record={advt}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    return items;
  };

  render() {
    let { advertisementsList, showModal } = this.props;
    let { search, pageNumber } = this.state;
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="ertical-align-center">
            <ContentIcon heading={HEADING_ADVERTISEMENT} />
          </div>
          <ul className="header-buttons">
            <li>
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.search}
                type="text"
                value={search}
                onChange={this.handleSearch}
              />
            </li>
            <li>
              <Button className="btn-custom-blue" onClick={this.open}>
                <img
                  style={{ paddingRight: 8, paddingBottom: 3 }}
                  src="../../style/images/header-icons/plus.png"
                ></img>
                {LocaleStrings.button_add_new}
              </Button>

              {showModal && showModal.showModal === true ? (
                <AddNew
                  history={this.props.history}
                  finishOperationsCallback={this.additionCallback}
                />
              ) : (
                ""
              )}
            </li>
          </ul>
        </div>
        <div className="clearfix" />

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : advertisementsList &&
            advertisementsList.data &&
            advertisementsList.data.length > 0 ? (
            <table className="table">
              <thead>
                <tr>
                  <th>{LocaleStrings.advt_modal_th_name}</th>
                  <th>{LocaleStrings.advt_modal_th_screen}</th>
                  <th>{LocaleStrings.advt_modal_th_action}</th>
                </tr>
              </thead>
              <tbody className="tbody-background">{this.renderList()}</tbody>
            </table>
          ) : (
            <NoContent contentType={NO_ADVERTISEMENTS} />
          )}

          {advertisementsList && advertisementsList.count > itemCount ? (
            <Pagination
              activePage={pageNumber}
              itemsCountPerPage={itemCount}
              totalItemsCount={advertisementsList.count}
              pageRangeDisplayed={10}
              onChange={this.paginationCallback}
              style={{ float: "right" }}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    advertisementsList: state.advertisementsList,
    showModal: state.advtAddModal,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps, {
  fetchAdvertisements,
  searchAdvertisements,
  openAdvtModal,
  advtBanners,
  fetchAllSponsors,
  fetchAllExhibitors,
  loadAdvtData,
})(Advertisement);
